import * as yup from 'yup';

export const validationSchema = yup.object().shape({
  backgroundColor: yup.string().required('Háttérszín megadása kötelező!'),
  textColor: yup.string().required('Szövegszín megadása kötelező!'),
  buttonColor: yup.string().required('Gomb színének megadása kötelező!'),
  buttonTextColor: yup.string().required('Gomb szövegének megadása kötelező!'),
});
